import React from 'react';
import type { SortDir } from '../../lib/types';
import styles from './Devices.module.scss';

interface SortableHeaderProps {
  label: string;
  /** Whether this column is the one currently sorted. */
  active: boolean;
  /** Current sort direction (only meaningful when `active`). */
  dir?: SortDir;
  onClick: () => void;
}

/**
 * A clickable `<th>` that toggles sorting on its column. Shared by the Devices
 * page tables (Activated via {@link DeviceSectionTable}, Stalled via
 * {@link StalledTransfersTable}) so the header markup, arrow glyphs, and
 * aria-sort mapping stay identical across them.
 */
export default function SortableHeader({ label, active, dir, onClick }: SortableHeaderProps) {
  return (
    <th aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button
        type="button"
        className={`${styles.sortHeader}${active ? ` ${styles.sortHeaderActive}` : ''}`}
        onClick={onClick}
      >
        <span>{label}</span>
        <span className={`${styles.sortArrow}${active ? ` ${styles.sortArrowActive}` : ''}`} aria-hidden="true">
          {active ? (dir === 'asc' ? '▴' : '▾') : '⇅'}
        </span>
      </button>
    </th>
  );
}
